<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        History Transaction
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>No.Kontrak</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.nokontrak"
              @keyup.13.native="lkuPinjamanShow = true"
              :state="!$v.model.pinjamankey.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuPinjamanShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.debitur_name" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Uraian</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.penggunaan" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl.Buka</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.tglkontrak"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jatuh Tempo</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.tglkontrak"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Periode</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.startdate"
              :state="!$v.model.startdate.$error"
              type="date"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input
              v-model="model.enddate"
              :state="!$v.model.enddate.$error"
              type="date"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.modelkredit == 'PAB'">
                <label>Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label>Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.modelkredit == 'PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.tenor"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interest"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.modelkredit == 'PAB'">
              <b-input-group-prepend>
                <label>Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interestod"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <button class="btn btn-success mr-1" @click="getHistoryTrx()">
              <i class="fa fa-play"></i> Proses
            </button>
            <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Cetak
            </button>
          </b-input-group>
        </b-col>
      </b-row>

      <hr />
      <b-card border-variant="info" header="History" align="center" no-body>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size: smaller"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          show-empty
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(seq)="data">{{ ((tblData.page-1)*tblData.limit)+(data.index + 1) }}</template>
          <template v-slot:cell(tgl_mutasi)="data">{{
            data.item.tgl_mutasi | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(mutasi_debet)="data">{{
            data.item.mutasi_debet | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(mutasi_kredit)="data">{{
            data.item.mutasi_kredit | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(saldo)="data">{{
            data.item.saldo | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(total_bunga)="data">{{
            data.item.total_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(total_denda)="data">{{
            data.item.total_denda | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bunga_denda_harian)="data">{{
            data.item.bunga_denda_harian | numFormat("0,0.00")
          }}</template>
          <template v-if="tblData.items.length > 0" v-slot:custom-foot>
            <b-tr>
              <b-td colspan="8"></b-td>
              <!-- <b-td class="text-right"><strong>{{total.total_bunga|numFormat('0,0.00')}}</strong></b-td> -->
              <b-td class="text-right"
                ><strong>{{
                  model.modelkredit == "PAB"
                    ? total.total_denda
                    : total.total_bunga | numFormat("0,0.00")
                }}</strong></b-td
              >
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="4" align="left">
            <div class="ml-2">
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
              to
              <span v-if="tblData.page * tblData.limit > tblData.total">{{
                tblData.total
              }}</span>
              <span v-else>{{ tblData.page * tblData.limit }}</span>
              of {{ tblData.total }} entries.
            </div>
          </b-col>
          <b-col cols="4">
            <b-row class="justify-content-center">
              <b-col cols="12">
                <div style="display: flex; margin: 0; padding: 0">
                  <div
                    style="
                      margin: 0;
                      padding: 5px;
                      width: 500px;
                      text-align: center;
                    "
                  >
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblData.limit" style="width: 60px">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';
import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import trxhistory from "../../apis/trxhistory";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading,myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
      startdate: { required },
      enddate: { required },
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      model: {
        pinjamankey: "",
        startdate: moment().startOf("month").format("YYYY-MM-DD"),
        enddate: moment().endOf("month").format("YYYY-MM-DD"),
      },
      lkuPinjamanShow: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpaym",
        sortDesc: true,
      },
      filterShow: "Show",
      filter: null,
      filterOn: [],
      total: {},
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "seq",
          label: "No.",
          thStyle: "width:120px",
          tdClass: "text-center",
          sortable: true,
          filterable: true,
        },
        {
          key: "tgl_mutasi",
          thStyle: "width:120px",
          thClass: "text-center",
            tdClass: "text-right",
          label: "Tgl. Mutasi",
          sortable: true,
        },
        // {
        //   key: "sandi_trans",
        //   label: "Sandi Trans",
        //   thStyle: "width:100px",
        //   tdClass: "text-center",
        //   sortable: true,
        //   filterable: true,
        // },
        {
          key: "mutasi_debet",
          label: "Mutasi Debet",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "mutasi_kredit",
          label: "Mutasi Kredit",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "saldo",
          label: "Saldo",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "keterangan",
          label: "Keterangan",
          tdClass: "text-left",
          filterable: true,
          sortable: true,
        },
        {
          key: "lama_hari_DENBUNG",
          label: `Lama Hari Bunga/Denda`,
          thStyle: "width:120px",
          thClass: "text-center",
          sortable: true,
          filterable: true,
        },
        {
          key: "bunga_denda_harian",
          label: `Bunga/Denda Per Hari`,
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "total_bunga",
          label: "Total Bunga/Denda",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        // {
        //   key: "total_denda",
        //   label: "Total Denda",
        //   thStyle: "width:120px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
      ];
      return fields;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    if (this.$route.params.pinjamankey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    onSelectLkuPinjaman(_selected) {
      this.filterShow = "Show";
      this.model.pinjamankey = _selected.pinjamankey;
      this.model.nokontrak = _selected.no_kontrak;
      this.model.tglkontrak = _selected.tgl_kontrak
        ? moment(_selected.tgl_kontrak).format("YYYY-MM-DD")
        : "";
      this.model.debitur_name = _selected.CustName;
      this.model.penggunaan = _selected.uraian;
      this.model.modelkredit = _selected.model_pinjaman;
      this.model.matauang = _selected.matauang;
      this.model.principal = _selected.principal;
      this.model.tenor = _selected.tenor;
      this.model.interest = _selected.interest;
      this.model.installment_amount = _selected.installment_amount;
      this.model.interstod = _selected.interstod;
      this.model.nasabahkey = _selected.nasabahkey;
      this.lkuPinjamanShow = false;
      this.$refs.table.fields[6].label = `Lama Hari ${
        this.model.modelkredit == "PAB" ? "Denda" : "Bunga"
      }`;
      this.$refs.table.fields[7].label = `${
        this.model.modelkredit == "PAB" ? "Denda" : "Bunga"
      } Per Hari`;
      this.$refs.table.fields[8].key = `${
        this.model.modelkredit == "PAB" ? "total_denda" : "total_bunga"
      }`;
      this.$refs.table.fields[8].label = `Total ${
        this.model.modelkredit == "PAB" ? "Denda" : "Bunga"
      }`;

      this.$refs.table.refresh();
    },
    async getHistoryTrx() {
      try {
        if (this.invalidModel) {
          // console.log("validation : ", this.$v.model);
          // console.log("model obj : ", this.model);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          const { trxb4, trx } = await trxhistory.detail(this.model);
          const total = {
            total_bunga: trxb4.total_bunga,
            total_denda: trxb4.total_denda,
          };
          const data = [
            {
              tgl_mutasi: moment(this.model.startdate).subtract(1, "days"),
              sandi_trans: "-",
              mutasi_debet: trxb4.mutasi_debet,
              mutasi_kredit: trxb4.mutasi_kredit,
              saldo: trxb4.mutasi_debet - trxb4.mutasi_kredit,
              keterangan: "SALDO AWAL",
              bunga_denda_harian: 0,
              lama_hari_DENBUNG: 0,
              total_bunga: trxb4.total_bunga,
              total_denda: trxb4.total_denda,
            },
          ];
          trx.map((item, idx) => {
            const saldoB4 =
              trx[idx - 1] && trx[idx - 1].saldo ? trx[idx - 1].saldo : 0;
            trx[idx].saldo =
              saldoB4 + (trx[idx].mutasi_debet - trx[idx].mutasi_kredit);
            total.total_bunga += trx[idx].total_bunga;
            total.total_denda += trx[idx].total_denda;
            data.push(trx[idx]);
          });
          this.total = total;
          this.tblData.items = data;
          this.tblData.total = data.length;
        }
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async print() {
      try {
        if (this.invalidModel) {
          // console.log("validation : ", this.$v.model);
          // console.log("model obj : ", this.model);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.reportUrl = await trxhistory.printpdf(this.model)
          this.showReport = true;
        }
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>
